export default "__VITE_ASSET__$g1Fjc7T__"